import { TallyQuestion } from "../../api/types/tally";

export const getTallyQuestionType = (question: TallyQuestion): string => {
  const fieldQuestionType = question.fields?.find(
    (field: Record<string, unknown>) => typeof field.questionType === "string",
  )?.questionType;

  if (typeof fieldQuestionType === "string" && fieldQuestionType !== "") {
    return fieldQuestionType;
  }

  const propertyQuestionType = question.properties?.questionType;
  if (typeof propertyQuestionType === "string" && propertyQuestionType !== "") {
    return propertyQuestionType;
  }

  return question.type ?? "";
};
